// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidMeal from '../_raw/service/icon_covid_meal.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidMeal);
